// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"7538":"recorder","9983":"profiler"}[chunkId] + "." + {"7538":"af14ae3c2f695d30","9983":"376e06f05be35c0e"}[chunkId] + ".js";
};